import React from 'react';
import FormUsersList from './FormUsersList';

const TeamForm = ({ 
  editingTeam, 
  formData, 
  setFormData, 
  selectedUsers, 
  setSelectedUsers, 
  onSubmit, 
  onCancel
}) => {
    // API base URL
  const API_BASE_URL = '/pceapi/teams';
  // Handle form input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Handle access level change
  const handleAccessLevelChange = (e) => {
    const value = e.target.value;
    setFormData(prev => ({ ...prev, team_access_level: value }));
  };

  // Handle user selection for access
  const handleUserSelection = (userId) => {
    if (selectedUsers.includes(userId)) {
      setSelectedUsers(prev => prev.filter(id => id !== userId));
    } else {
      setSelectedUsers(prev => [...prev, userId]);
    }
  };

  return (
    <div className="ev-card-2 w-100 ev-padding-xlarge vh-70">
      <p className="ev-med-p-dark mb-3">
        {editingTeam ? 'Edit Team Details' : 'Create Team'}
      </p>
      
      <form onSubmit={onSubmit}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group mb-3">
              <label className="ev-reg-p-dark mb-2">Team Name <span className="text-danger">*</span></label>
              <input 
                type="text" 
                className="formField3" 
                name="name" 
                value={formData.name} 
                onChange={handleInputChange} 
                required 
                placeholder="Enter team name"
              />
            </div>
            
            <div className="form-group mb-3">
              <label className="ev-reg-p-dark mb-1">Access Level <span className="text-danger">*</span>&nbsp; &nbsp; </label>
              <div className="btn-group custom-btn-group-outer w-50" role="group" aria-label="Access Level Selection">
                <button 
                  type="button" 
                  className={`btn custom-btn-group-inner ${formData.team_access_level === 'PUBLIC' ? 'ev-btn-blue-fill-round' : 'ev-btn-lightblue-fill-round'}`}
                  onClick={() => handleAccessLevelChange({ target: { name: 'team_access_level', value: 'PUBLIC' } })}
                >
                  Public
                </button>
                <button 
                  type="button" 
                  className={`btn custom-btn-group-inner ${formData.team_access_level === 'PRIVATE' ? 'ev-btn-blue-fill-round' : 'ev-btn-lightblue-fill-round'}`}
                  onClick={() => handleAccessLevelChange({ target: { name: 'team_access_level', value: 'PRIVATE' } })}
                >
                  Private
                </button>
              </div>
            </div>
            
            {/* Always show team members section regardless of access level */}
            <div className="form-group">
              <label className="ev-reg-p-dark mb-1">Team Members <span className="ev-small-p-blue"><i>(Optional)</i></span></label>
              <FormUsersList 
                apiBaseUrl={API_BASE_URL}
                selectedUsers={selectedUsers}
                onSelectUser={handleUserSelection}
                ownerEmail={editingTeam ? editingTeam.created_by_email : null}
              />
            </div>
          </div>
          
          <div className="col-md-6">
            <div className="alert alert-info mt-4">
              <i className="bi bi-info-circle me-1"></i>
              <b>Note:</b> {editingTeam ? 
                "You are editing an existing team. Changes to members will update their access rights." :
                "Creating a new team will allow you to manage access for a group of users."
              }
            </div>
            
            {formData.team_access_level === 'PUBLIC' && (
              <div className="alert alert-warning" >
                <i className="bi bi-exclamation-triangle me-1"></i>
                <b>Public Team:</b> The team will be visible to all users, but only selected members will have access to team resources.
              </div>
            )}
            
            {formData.team_access_level === 'PRIVATE' && (
              <div className="alert alert-primary" >
                <i className="bi bi-shield-lock me-1"></i>
                <b>Private Team:</b> The team will only be visible to selected members, and only they will have access to team resources.
              </div>
            )}
            
            <div className="mt-4 text-end">
              <button type="submit" className="ev-btn-blue-fill-round ev-bold-reg" >
                <i className="bi bi-cursor-fill"></i> {editingTeam ? 'Update Team' : 'Create Team'}
              </button>
              <span>&nbsp;&nbsp;</span>
              <button 
                type="button" 
                className="ev-btn-blue-outline-round ms-2" 
                onClick={onCancel}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default TeamForm;